import * as yup from "yup";

const operatorAccountScheme = yup.object().shape({
  email: yup
    .string()
    .email("Invalid email id")
    .required("Email Id is required"),
  phoneNumber: yup
    .string()
    .required("Phone Number is required")
    .matches(/^\d{10}$/, "Invalid phone number"),
  firstName: yup.string().required("Name is required"),
  lastName: yup.string().required("Name is required"),
  countryCode: yup.string().required("Country Code is required"),
  password: yup
    .string()
    .required("Password is required")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()-_+=])[A-Za-z\d!@#$%^&*()-_+=]{8,}$/,
      "Invalid Password",
    ),
});

export default operatorAccountScheme;
